import {
  BoltIcon,
  CalendarDaysIcon,
  FingerPrintIcon,
  LockClosedIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";

interface PrimaryFeature {
  name: string;
  description: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
}

const primaryFeatures: PrimaryFeature[] = [
  {
    name: "Real-Time User Authentication",
    description:
      "Seamless authentication and single sign-on experience for your users across all your applications.",
    href: "#",
    icon: FingerPrintIcon, // You can change the icon here if needed
  },
  {
    name: "Cross-Platform Integration",
    description:
      "Integrate your SSO across various platforms like mobile, web, and cloud seamlessly for a unified experience.",
    href: "#",
    icon: UsersIcon,
  },
  {
    name: "Secure Data Protection",
    description:
      "Utilize end-to-end encryption to ensure the security and privacy of your user data throughout the authentication process.",
    href: "#",
    icon: LockClosedIcon,
  },
];

export const PrimaryFeatures = () => {
  return (
    <div className="mx-auto mt-32 max-w-7xl px-6 sm:mt-56 lg:px-8">
      <div className="mx-auto max-w-2xl lg:text-center">
        <h2 className="text-base/7 font-semibold text-indigo-400">
          Seamless Integration
        </h2>
        <p className="mt-2 text-4xl font-semibold tracking-tight text-pretty text-white sm:text-5xl lg:text-balance">
          Integrate SSO in Minutes
        </p>
        <p className="mt-6 text-lg/8 text-gray-300">
          Effortlessly integrate Single Sign-On and streamline your app
          deployment with just a few clicks.
        </p>
      </div>
      <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
        <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
          {primaryFeatures.map((feature) => (
            <div key={feature.name} className="flex flex-col">
              <dt className="text-base/7 font-semibold text-white">
                <div className="mb-6 flex size-10 items-center justify-center rounded-lg bg-indigo-500">
                  <feature.icon
                    aria-hidden="true"
                    className="size-6 text-white"
                  />
                </div>
                {feature.name}
              </dt>
              <dd className="mt-1 flex flex-auto flex-col text-base/7 text-gray-300">
                <p className="flex-auto">{feature.description}</p>
                <p className="mt-6">
                  <a
                    href={feature.href}
                    className="text-sm/6 font-semibold text-indigo-400"
                  >
                    Learn more <span aria-hidden="true">→</span>
                  </a>
                </p>
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
};
